import { FieldType } from "./field-type.enum";
import { RowType } from "./raw-type.enum";

export class GenericTableColumn<T> {
  header: string;
  field?: string; //will be used for sorting
  sortable: boolean;
  sortAsc: boolean;
  style: any;
  class: string;
  fieldType: FieldType;
  RowType: RowType;
  doubleRowField?: IDoubleRaw<T>;
  noteRow?: INoteRow<T>;
  locationRow?: ILocationRow<T>;
  nameRow?: INameRow<T>;
  additionalProps?: IAdditionalPropsForTheRow<T>;
  tdClass?: string;
  showInputErrors?: boolean;
  elementStyle?: any;
  headerDisplayPredicate?: Function;
  rowValueDisplayPredicate?: Function;
  constructor(init: {
    header: string;
    field?: string
    sortable?: boolean;
    sortAsc?: boolean;
    style?: any;
    class?: string;
    fieldType?: FieldType;
    RowType?: RowType;
    doubleRowField?: IDoubleRaw<T>;
    noteRow?: INoteRow<T>;
    locationRow?: ILocationRow<T>;
    nameRow?: INameRow<T>;
    additionalProps?: IAdditionalPropsForTheRow<T>;
    tdClass?: string;
    showInputErrors?: boolean;
    elementStyle?: any;
    headerDisplayPredicate?: Function;
    rowValueDisplayPredicate?: Function;
  }) {
    this.header = init.header;
    this.field = init.field;
    this.sortable = init.sortable ?? true;
    this.sortAsc = init.sortAsc ?? true;
    this.style = init.style ?? {};
    this.class = init.class;
    this.fieldType = init.fieldType ?? FieldType.Text;
    this.RowType = init.RowType ?? RowType.Single;
    this.doubleRowField = init.doubleRowField;
    this.noteRow = init.noteRow;
    this.locationRow = init.locationRow;
    this.nameRow = init.nameRow;
    this.additionalProps = init.additionalProps;
    this.tdClass = init.tdClass;
    this.showInputErrors = init.showInputErrors;
    this.elementStyle = init.elementStyle ?? {};
    this.headerDisplayPredicate = typeof init.headerDisplayPredicate === 'function' ? init.headerDisplayPredicate : () => true;
    this.rowValueDisplayPredicate = typeof init.rowValueDisplayPredicate === 'function' ? init.rowValueDisplayPredicate : () => true;
  }
}

export interface IDoubleRaw<T> {
  headingField: string;
  headingFieldType?: FieldType;
  headingField2?: string;
  headingField2Type?: FieldType;
  secondaryField1: string;
  secondaryFieldType1?: FieldType;
  secondaryField2?: string
  secondaryFieldType2?: FieldType;
}

export interface INoteRow<T> {
  noteDrugNameField?: keyof T;
}

export interface ILocationRow<T> {
  startingField: keyof T;
  countField: keyof T;
  onHandField: keyof T;
  drugIDField: keyof T;
}

export interface INameRow<T> {
  firstNameField: keyof T;
  lastNameField: keyof T;
}

//Use and expand with properties you need. Whatever property names sent from the API, will be standardized here.
export interface IAdditionalPropsForTheRow<T> {
  locationID?: keyof T;
  drugID?: keyof T;
}
